module.exports = __webpack_public_path__ + "static/media/organon.2425e7b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/organon.png
// module id = 140
// module chunks = 0